<template>
  <section class="stock-trade-ticks">
    <header><span>分时成交</span><button type="button" :aria-expanded="open" @click="toggle">{{ open ? '收起' : '展开' }}</button></header>
    <div v-if="open" class="ticks-body" v-loading="loading && !rows.length" element-loading-background="var(--theme-bg)">
      <table v-if="rows.length"><thead><tr><th>时间</th><th>成交价</th><th>成交量</th><th>方向</th></tr></thead>
        <tbody><tr v-for="row in rows" :key="row.id"><td>{{ row.time }}</td><td :class="tone(row)"><button type="button" class="quote-price" :disabled="!priceSelectable" title="点击填入限价" @click="$emit('select-price', row.price)">{{ priceDisplay(row.price) }}</button></td><td>{{ row.volume }}</td><td :class="tone(row)">{{ row.direction === 'B' ? '买' : row.direction === 'S' ? '卖' : '中性' }}</td></tr></tbody>
      </table>
      <p v-if="error" role="alert">{{ error }} <button type="button" @click="load">重试</button></p>
      <p v-else-if="!loading && !rows.length">暂无分时成交</p>
    </div>
  </section>
</template>
<script>
import { quotePrice } from '@/utils/quoteDisplay'
import { pollMarket } from '@/utils/marketRefresh'
import { workspaceTrades } from '@/utils/workspaceQuotes'
export default {
  props: { symbol: String, priceSelectable: Boolean, market: { type: String, default: 'cn' } },
  data: () => ({ open: false, rows: [], loading: false, initialized: false, error: '', sequence: 0 }),
  watch: { symbol() { this.stopPolling(); this.sequence++; this.rows = []; this.error = ''; this.loading = false; this.initialized = false; if (this.open) this.activate() } },
  beforeDestroy() { this.disposed = true; this.sequence++; this.stopPolling() },
  methods: {
    priceDisplay: quotePrice,
    tone(row) { return row.direction === 'B' ? 'rise' : row.direction === 'S' ? 'fall' : '' },
    stopPolling() { if (this.stopTicks) this.stopTicks(); this.stopTicks = null },
    activate() {
      if (this.disposed || !this.open || this.stopTicks) return
      this.load()
      this.stopTicks = pollMarket(() => this.load(), 2000, () => this.market)
    },
    toggle() { this.open = !this.open; this.$emit('toggle', this.open); if (this.open) this.activate(); else this.stopPolling() },
    async load() {
      if (this.disposed || !this.open || this.loading || !this.symbol) return
      const sequence = this.sequence
      this.loading = true; this.error = ''
      try {
        const rows = await workspaceTrades(this.symbol, !this.initialized)
        if (sequence !== this.sequence) return
        this.rows = rows; this.initialized = true
      } catch (_) {
        if (sequence === this.sequence) this.error = this.rows.length ? '分时成交暂未更新，当前显示最近一次数据' : '暂时无法获取分时成交，请重试'
      } finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>
<style scoped>
header { display: flex; justify-content: space-between; align-items: center; height: 36px; padding: 0 13px; background: var(--theme-header); }
button { border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
.ticks-body { max-height: 280px; min-height: 40px; overflow-y: auto; }
table { width: 100%; border-collapse: collapse; text-align: center; font-size: 13px; }
th { position: sticky; top: 0; background: var(--theme-bg); color: var(--theme-muted); font-weight: normal; }
th, td { padding: 6px 4px; }
p { padding: 8px; color: var(--theme-muted); text-align: center; }
.rise { color: var(--quote-up); } .fall { color: var(--quote-down); }
</style>
